import {
  compose, withHandlers,
} from 'recompose';
import { connect } from 'react-redux';

import { withTranslation } from 'react-i18next';
import { push } from 'connected-react-router';
import JoinToChannel from './joinToChannel';
import { getActiveChannelEntity, joinToChannelPending } from '../../../../state/messenger/selectors';
import { joinToChannelRequest } from '../../../../state/messenger/actions';
import { withForwardingRef } from '../../../../utils/enchancers';

const mapStateToProps = state => ({
  channel: getActiveChannelEntity(state),
  isPending: joinToChannelPending(state),
});

const mapDispatchToProps = {
  joinToChannel: joinToChannelRequest,
  pushRouter: push,
};

const onJoinToChannelHandler = ({
  joinToChannel, channel: { id },
  updateMessageContainerHeight,
}) => () => {
  joinToChannel({ id }, {
    callbacks: {
      success: updateMessageContainerHeight,
    },
  });
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation(['common', 'chat']),
  withForwardingRef,
  withHandlers({
    onJoinToChannel: onJoinToChannelHandler,
  }),
);
export default enhance(JoinToChannel);
